module.exports = __webpack_public_path__ + "img/bottom_cover.e064db56.png";